module.exports = __webpack_public_path__ + "img/2024-03-19f_1.27f6a4a9.jpg";